app.service('sortBar', function(modal) {
	let sortListModal;

	function init() {
		setEvents();
	}

	function setEvents() {
		$('#sort-box').on('click', 'a', function() {
			UA.interaction(
				'Listing - Sortowanie',
				'Sortowanie',
				$(this)
					.text()
					.trim()
			);
		});

		$('#sort-btn').on('click', () => {
			if (sortListModal) {
				return sortListModal.open();
			}

			sortListModal = modal.generate({
				header: 'Sortowanie',
				content: $('#sort-box'),
				modifier: 'remodal-full-width'
			});
		});
	}

	return {
		init
	};
});
